import { render, staticRenderFns } from "./CustomerWidget.vue?vue&type=template&id=08278eb3&"
import script from "./CustomerWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports